// App.js
import React, { useState, useEffect } from 'react';
import MainPage from './components/MainPage';
import PublicStoryLibrary from './components/PublicStoryLibrary';
import './App.css';

const PASSWORD = 'JB!';
export default function App() {
  // ------ view & auth state ------
  const [isWriter, setIsWriter] = useState(false);      // which page to show
  const [stories, setStories] = useState([]);           // share stories in both views
  const [loginVisible, setLoginVisible] = useState(false);
  const revealLoginButton = () => setLoginVisible(true);
  // ------ one-time load of stories ------
  useEffect(() => {
    fetch('https://storypublisher.onrender.com/stories')
      .then(res => res.json())
      .then(data => setStories(data))
      .catch(err => console.error('Could not load stories', err));
  }, []);

  // ------ footer button handlers ------
  const handleLogin = () => {
    const attempt = prompt('Writer password:');
    if (attempt === PASSWORD) {
      setIsWriter(true);
    } else if (attempt !== null) {
      alert('Incorrect password ❌');
    }
  };

  const handleLogout = () => setIsWriter(false);

  // ------ render ------
  return (
    <div className="App">
      {isWriter ? (
        <MainPage                           /* writer interface  */
          stories={stories}
          setStories={setStories}
        />
      ) : (
        <PublicStoryLibrary                 /* public reader view */
          stories={stories}
          onSecretTrigger={revealLoginButton}
        />
      )}

      {/* ------- fixed footer ------- */}
      <footer style={{ marginTop: '40px' }}>
        {isWriter ? (
          <button onClick={handleLogout}>Logout to Public</button>
        ) : loginVisible ? (
          <button onClick={handleLogin}>Writer&nbsp;Login</button>
        ) : null}
      </footer>
    </div>
  );
}
